import { BaseLogo } from "../../core/models/entities/BaseLogo";
import { Role } from "../../core/models/entities/Role";
import { enviroment } from "../../enviroment";

// "Reject and fix it myself" for a LOGO (flag
// REACT_APP_LOGO_REJECT_AND_EDIT_ENABLED, Nichlas 17/10: «hvis det blot er en
// metode, farve eller størrelse»). Offered to the dealer only - in practice
// an admin only in act-as-vendor, where the role is Vendor; ApprovalVoting's
// showButtons never shows Approve/Reject for Role.Admin itself, so letting
// Admin through here is harmless (the customer's reject dialog is
// untouched) - and only for a logo the popup's own
// Edit is shown for - not yet committed to the supplier (a real serial as
// SKU hides Edit today: its method / size are the supplier's). The same SKU
// rule as the popup's two Edit gates. Always false with the flag off.
export function canLogoRejectAndEdit(logo: BaseLogo, role?: Role): boolean {
  if (!enviroment.logoRejectAndEditEnabled) return false;
  if (role === Role.EndUser) return false;
  const isCommitted =
    logo.product?.sku != null && !logo.product.sku.includes("UPLOAD_");
  return !isCommitted;
}
